__turbopack_context__.v({
  "badge": "NotificationCardIcon-module-scss-module___98eua__badge",
  "badgeError": "NotificationCardIcon-module-scss-module___98eua__badgeError",
  "badgeIcon": "NotificationCardIcon-module-scss-module___98eua__badgeIcon",
  "badgeInfo": "NotificationCardIcon-module-scss-module___98eua__badgeInfo",
  "badgeStar": "NotificationCardIcon-module-scss-module___98eua__badgeStar",
  "badgeWarning": "NotificationCardIcon-module-scss-module___98eua__badgeWarning",
  "customIcon": "NotificationCardIcon-module-scss-module___98eua__customIcon",
  "icon": "NotificationCardIcon-module-scss-module___98eua__icon",
  "iconWrap": "NotificationCardIcon-module-scss-module___98eua__iconWrap",
});
